export enum GraduationDocumentLanguage {
  emakeelEt = 'EMAKEEL:ET',
  emakeelEn = 'EMAKEEL:EN',
}
